import React from 'react';
import { IonSelect, IonSelectOption } from '@ionic/react';

function SportsField({ placeholder, value, setter, sports }) {
  return (
    <IonSelect
      className='entry-field'
      placeholder={placeholder}
      interface='popover'
      fill='outline'
      shape='round'
      value={value}
      onIonChange={event => setter?.(event.target.value)}
      multiple>
      {sports.map(sport => (
        <IonSelectOption key={sport}>{sport}</IonSelectOption>
      ))}
    </IonSelect>
  );
}

export default SportsField;
